module.exports = __webpack_public_path__ + "img/el-kios-thumb.733d41f6.jpg";